import { listify } from 'radash'

export const SimpleDictTable = ({colDefs, rows, renderCell}) =>
    <table className="w-full text-sm text-left text-gray-700 border-collapse">
        <thead>
            <tr>
            {
                listify(
                    colDefs,
                    (k, label) =>
                        <th
                            key={k}
                            className="px-3 py-2 bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500 border-b border-slate-300 whitespace-nowrap"
                        >
                            {label}
                        </th>
                )
            }
            </tr>
        </thead>
        <tbody>
        {
            rows.map(
                (o,idx) => <tr key={`r-${idx}`}>
                    {
                        listify(
                            colDefs,
                            (k, _) =>
                                <td
                                    key={`r${idx}-${k}`}
                                    className="px-3 py-2 border-b border-slate-200"
                                >
                                    {renderCell?.[k] ? renderCell[k](o[k], o) : o[k]}
                                </td>
                        )
                    }
                </tr>
            )
        }
        </tbody>
    </table>

export const DecoratedSimpleDictTable = ({
    colDefs,
    colDescriptions = {},
    rows,
    renderCell
}) =>
    <table className="w-full text-sm text-left text-gray-700 border-collapse">
        <thead>
            <tr>
                {
                    listify(
                        colDefs,
                        (key, label) =>
                            <th
                                key={key}
                                className="px-3 py-2 bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500 border-b border-slate-300 whitespace-nowrap"
                            >
                                <div className="group relative inline-block cursor-default">
                                    <span>{label}</span>

                                    {colDescriptions[key] ? (
                                        <div
                                            className="
                                                invisible absolute bottom-full right-0 z-50 mb-1
                                                w-80 max-w-xs
                                                rounded bg-blue-400 p-2
                                                text-left text-xs font-normal normal-case text-white
                                                opacity-0 transition
                                                group-hover:visible group-hover:opacity-100
                                                whitespace-pre-line break-words
                                            "
                                        >
                                            {colDescriptions[key]}
                                        </div>
                                    ) : null}
                                </div>
                            </th>
                    )
                }
            </tr>
        </thead>

        <tbody>
            {
                rows.map(
                    (row, rowIndex) =>
                        <tr key={`r-${rowIndex}`}>
                            {
                                listify(
                                    colDefs,
                                    (key) =>
                                        <td
                                            key={`r${rowIndex}-${key}`}
                                            className="px-3 py-2 border-b border-slate-200"
                                        >
                                            {renderCell?.[key]
                                                ? renderCell[key](row[key], row)
                                                : row[key]}
                                        </td>
                                )
                            }
                        </tr>
                )
            }
        </tbody>
    </table>